import React, { FunctionComponent } from 'react';
import { Flex } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';

const backgroundColor = theme('mode', {
  light: (props: any) => props.theme.colors.glitter,
  dark: (props: any) => props.theme.gradients.backgroundDarkTheme,
});

const AppWrapperContainer = styled(Flex)`
  height: 100%;
  overflow: hidden;
  background: ${backgroundColor};
`;

export interface AppWrapperProps {
  children: React.ReactNode;
}

const AppWrapper: FunctionComponent<AppWrapperProps> = ({ children }: AppWrapperProps) => (
  <AppWrapperContainer data-testid="app">
    {children}
  </AppWrapperContainer>
);

export default AppWrapper;
